import { createAsyncThunk } from '@reduxjs/toolkit'
import { SippApi } from '../../../services/SippExpress'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { WaterTestStripResultDocument } from '../../../types'



interface RequestOptions {
  options?: AxiosRequestConfig
}

export const fetchWaterTestKitResultsAsync = createAsyncThunk<
  any,
  RequestOptions
>(
  'watertestkitresults/fetch',
  async ({options}, { rejectWithValue }) => {
    try {
     const response = await SippApi.fetch.waterTestKitResults(options) as AxiosResponse<Partial<WaterTestStripResultDocument>[]>
     return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)


export const fetchWaterTestKitResultsAsyncBuilder = (builder: any) => {
  builder.addCase(fetchWaterTestKitResultsAsync.pending, (state, ) => {
    state.loading = true;
    state.error = null;
  })
  builder.addCase(fetchWaterTestKitResultsAsync.fulfilled, (state, action, ) => {
    state.loading = false;
    state.data = action.payload;
  })
  builder.addCase(fetchWaterTestKitResultsAsync.rejected, (state, action ) => {
    state.loading = false;
    state.error = action.payload.message;
  })
}